import { hdImages } from "@/lib/hd-images";
import { Media } from "./Media";

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "./ui/hover-card";

export const PhotoMosaic = () => {
  const images = [
    {
      src: hdImages.mosaicICU,
      alt: "Intensive care unit bay equipped for AIMediQ™ guided resuscitation",
      tall: true,
      title: "Intensive Care Unit",
      description: "Modern ICU environments require split-second decisions. datasyteAI™ integrates seamlessly into critical care workflows.",
    },
    {
      src: hdImages.mosaicMeds,
      alt: "Nurse preparing resuscitation medications with AIMediQ™ dosing prompts",
      title: "Medication Management",
      description: "Precise medication dosing and timing are crucial during Code Blue events. AI guidance helps prevent errors under pressure.",
    },
    {
      src: hdImages.mosaicDefib,
      alt: "Defibrillator and patient monitor showing live rhythm analysis during a code",
      title: "Defibrillation & Monitoring",
      description: "Real-time rhythm analysis and defibrillation timing prompts ensure optimal shock delivery during cardiac emergencies.",
    },
    {
      src: hdImages.mosaicTeam,
      alt: "Code Blue team coordinating compressions and airway with on-screen cues",
      title: "Team Synchronization",
      description: "Coordinated team response is essential. Visual and audio cues keep everyone aligned during high-stress resuscitations.",
    },
    {
      src: hdImages.mosaicLead,
      alt: "Code leader reviewing an auto-captured resuscitation timeline after the event",
      title: "Clinical Leadership",
      description: "Code leaders can focus on patient care while AI handles timing, documentation, and protocol adherence.",
    },
  ];

  return (
    <section className="py-14" aria-label="Visual highlights">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 auto-rows-[260px]">
          {images.map((image, index) => (
            <HoverCard key={index} openDelay={200} closeDelay={100}>
              <HoverCardTrigger asChild>
                <Media
                  src={image.src}
                  alt={image.alt}
                  sizes="(max-width: 640px) 50vw, (max-width: 1024px) 50vw, 400px"
                  className={`reveal rounded-xl object-cover w-full h-full cursor-pointer ${
                    image.tall ? "lg:row-span-2" : ""
                  } hover:-translate-y-2 transition-all duration-300`}
                />

              </HoverCardTrigger>
              <HoverCardContent className="w-80 bg-card/95 backdrop-blur-sm border-primary/20">
                <div className="space-y-2">
                  <h4 className="text-sm font-semibold text-primary">{image.title}</h4>
                  <p className="text-sm text-muted-foreground">{image.description}</p>
                </div>
              </HoverCardContent>
            </HoverCard>
          ))}
        </div>
      </div>
    </section>
  );
};
